// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"PageErrorMessage__Wrapper__1CIkA","errorMessage":"PageErrorMessage__errorMessage__2_IlV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/miscUtility/pageErrorMessage/PageErrorMessage.css
// module id = 150
// module chunks = 0